import { ReactNode } from 'react';
import ChartEmpty from './ChartEmpty';
import ChartError from './ChartError';
import ChartLoading from './ChartLoading';
import ChartHeader from './ChartHeader';
import { themeVars } from '@instamenu/ui-vanilla-extract';

export type ChartSectionProps = React.ComponentProps<typeof StyledContainer> & {
  children: ReactNode;
  error?: Error;
  loading: boolean;
  empty: boolean;
  css?: React.CSSProperties;
  Header?: typeof ChartHeader | ReactNode;
  divide?: boolean;
};

const StyledContainer = ({ children, css }: { children: ReactNode; css?: React.CSSProperties }) => (
  <div style={{ ...css, marginBottom: 20 }}>{children}</div>
);

const StyledDivider = () => <div style={{ borderTop: themeVars.border.default }} />;

export function ChartSection({
  children,
  error,
  loading,
  empty,
  Header,
  css,
  divide = false,
}: ChartSectionProps) {
  return (
    <StyledContainer css={css}>
      <>
        {Header}
        {error ? <ChartError /> : loading ? <ChartLoading /> : empty ? <ChartEmpty /> : children}
        {!divide && <StyledDivider />}
      </>
    </StyledContainer>
  );
}

export default ChartSection;
